import { render, staticRenderFns } from "./TagSkeleton.vue?vue&type=template&id=4f899328&scoped=true&"
import script from "./TagSkeleton.vue?vue&type=script&lang=js&"
export * from "./TagSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./TagSkeleton.vue?vue&type=style&index=0&id=4f899328&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f899328",
  null
  
)

export default component.exports